import { defaultFeatureFlags } from '../../../../../../backend/config/settings/featureFlags';
import { useAlertConfig, useAlertUiTranslation } from '../../../../../hooks';
import { useDeliveryMethodPanel } from './Panels/useDeliveryMethodPanel';
import { useDeliveryOrderPanel } from './Panels/useDeliveryOrderPanel';
import { usePhinMessagingPanel } from './Panels/usePhinMessagingPanel';
export function useDefineDeliveryStep(alert, shouldGenerateUniqueIdentifier) {
    const { features } = useAlertConfig();
    const featuresData = features && (features === null || features === void 0 ? void 0 : features.showPhin) ? features : defaultFeatureFlags.notifications;
    if (!featuresData.showPhin) {
        alert.phin = undefined;
        alert.phinOptions = undefined;
    }
    const { t } = useAlertUiTranslation();
    const panelConfig = { mode: 'edit' };
    return {
        label: t('wizard.defineDelivery.defineDelivery'),
        form: {
            type: 'form',
            children: [
                {
                    type: 'form.content',
                    style: {
                        paddingTop: 8,
                    },
                    key: 'content1',
                    html: `<h3>${t('wizard.defineDelivery.defineDelivery')}</h3>`,
                },
                usePhinMessagingPanel(Object.assign(Object.assign({ paddingTop: 36 }, panelConfig), { generateUniqueIdentifier: shouldGenerateUniqueIdentifier })),
                useDeliveryMethodPanel(Object.assign(Object.assign({}, panelConfig), { phinSelected: alert.phin })),
                useDeliveryOrderPanel(panelConfig),
            ],
        },
    };
}
